export default {
  "header": {
    "title": "Judul Sistem",
    "welcome": "Selamat datang kembali"
  },
  //首页
  "产品":"产品",
  "定价":"定价",
  "资源中心":"资源中心",
  "关于我们":"关于我们",
}


// WEBPACK FOOTER //
// ./src/lang/id.js